import { Button } from '@billy/design-system'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useSideNavbar } from '../../contexts/sideNavbarContext'
import { EnvironmentIndicator } from '../EnvironmentIndicator'
import { useNavigation } from './contexts/navigationContext'
import { AdvisorLayerModeProvider } from './elements/AdvisorLayer/contexts/advisorLayerModeContext'
import { AdvisorToggle } from './elements/AdvisorToggle'
import { NavigationMenu } from './elements/NavigationMenu'
import { NavigationMenuFooter } from './elements/NavigationMenuFooter'
import { OrganizationDropdown } from './elements/OrganizationDropdown'
import * as Styled from './styles'

export const Navigation = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { withSideNavbar } = useSideNavbar()
  const { closeNavigation, openNavigation, isNavigationOpen, variant } = useNavigation()
  useEffect(() => {
    closeNavigation()
  }, [location, closeNavigation])

  return (
    <>
      <Styled.NavigationWrapper forceOpen={isNavigationOpen} isMovedToRight={withSideNavbar} variant={variant}>
        <Styled.NavigationContentWrapper>
          <AdvisorLayerModeProvider>
            <div>
              <OrganizationDropdown />
              <AdvisorToggle />
              <NavigationMenu variant={variant} />
            </div>
            <NavigationMenuFooter variant={variant} />
          </AdvisorLayerModeProvider>
        </Styled.NavigationContentWrapper>
      </Styled.NavigationWrapper>

      <EnvironmentIndicator />

      <Styled.OpenButtonWrapper onClick={openNavigation} visible={!isNavigationOpen} isMovedToRight={withSideNavbar}>
        <Button icon="menu" size="lg">
          {t('menu')}
        </Button>
      </Styled.OpenButtonWrapper>
      <Styled.Overlay onClick={closeNavigation} visible={isNavigationOpen} />
    </>
  )
}
